export default __webpack_public_path__ + "static/UV Toyota Certified – 1280px-70757860ed1cc90735c8c719dd750fae.jpg";